import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import VacanciesPage from "./pages/VacanciesPage";
import AboutUs from "./pages/AboutUs";
import Posts from "./pages/Posts";
import ApplyNowPage from "./pages/ApplyNowPage";
import OurProjects from "./pages/OurProjects";
import AlgemeneVoorwaarden from "./pages/AlgemeneVoorwaarden";
import Privacybeleid from "./pages/Privacybeleid";
import ProjectDetail from "./pages/ProjectDetail";
import ServicePage from "./pages/ServicePage";

function App() {
  return (
    <Router>
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/vacancies" element={<VacanciesPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/post" element={<Posts />} />
          <Route path="/apply" element={<ApplyNowPage />} />
          <Route path="/projects" element={<OurProjects />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
          <Route path="/privacybeleid" element={<Privacybeleid />} />
          <Route path="/project/:projectId" element={<ProjectDetail />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
